"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _NoopWrapper = _interopRequireDefault(require("./NoopWrapper"));

var _default = _NoopWrapper.default;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-big-calendar/lib/BackgroundWrapper.js
// module id = 395
// module chunks = 0